import axios from '@service'
import { GET_SPECIAL_BANK_ACCOUNT_INFO } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 获取银行专户信息
export default async function getSpecialBankAccountInfoService(payload = {}, config = {}) {
    const param = {
        ...GET_SPECIAL_BANK_ACCOUNT_INFO,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
